/* eslint-disable complexity */
import {Loading, Loaded, NoResult, LoadError, CloseTips} from './status';
import {useEffect, useRef, useState, useCallback} from 'react';
import styles from './index.module.scss';
import {MenuItemId} from '@/components/Menu';
import MenuList from './MenuList';

interface IProps {
    list: Repository[];
    recentPathList?: Repository[];
    loadMore: (page: number) => void;
    hasMore: boolean;
    error: boolean;
    loading: boolean;
    className?: string;
    searchVal?: string;
    onSelectRepository: (guid: string) => void;
    newRepository: any;
    inputValue: string;
}

export function SidebarSearchList(props: IProps) {
    const {
        list = [],
        recentPathList = [],
        loadMore,
        hasMore = true,
        error = false,
        loading,
        onSelectRepository,
        className = '',
        searchVal = '',
        newRepository = '',
        inputValue = '',
    } = props;
    const [checkedRepo, setCheckedRepo] = useState('');
    const isLoadData = useRef(false);
    const [page, setPage] = useState(1);
    useEffect(() => {
        if (newRepository) {
            setCheckedRepo(JSON.stringify({
                groupGuid: newRepository.groupGuid,
                repositoryGuid: newRepository.repositoryGuid,
                spaceGuid: newRepository.spaceGuid,
                name: newRepository.name,
                roleName: newRepository.roleName,
            }));
        }
        isLoadData.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [list, newRepository]);

    function preventDefault(e: any) {
        e.preventDefault();
        e.stopPropagation();
    }

    const handleSelectRepository = useCallback((repositoryInfo: MenuItemId) => {
        onSelectRepository(repositoryInfo as string);
        setCheckedRepo(repositoryInfo as string);
    }, [onSelectRepository, setCheckedRepo]);

    const handleWheel = (e: any) => {
        // 当有惯性的wheel时间发生时需要等到wheel事件停止再去更新数据
        const listBox = document.querySelector('.browse-box') as HTMLDivElement;
        const {height} = listBox.getBoundingClientRect();
        const scrollTop = listBox.scrollTop;
        const scrollHeight = listBox.scrollHeight;
        // 顶部往上滚
        if (
            (scrollTop <= 5 && e.deltaY < 0)
            || (height + scrollTop >= (scrollHeight - 5) && e.deltaY > 0)
        ) {
            preventDefault(e);
        }
        // 底部往下滚
        if (
            (height + scrollTop >= (scrollHeight - 5) && e.deltaY > 0)
            && hasMore && !error && !isLoadData.current && loadMore
        ) {
            loadMore(page + 1);
            setPage(page + 1);
            isLoadData.current = true;
            // 在这里加载数据
            preventDefault(e);
        }
    };

    useEffect(() => {
        const listBox = document.querySelector('.browse-box') as HTMLDivElement;
        listBox && listBox.addEventListener('wheel', handleWheel);
        return () => {
            listBox && listBox.removeEventListener('wheel', handleWheel);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [list, hasMore]);

    useEffect(() => {
        setPage(1);
    }, [inputValue]);

    return (
        <div className={styles.root}>
            <div
                className="browse-box"
            >
                {
                    recentPathList.length > 0 && !searchVal ? <>
                        <div className={styles.listExplain}>最近使用</div>
                        <MenuList
                            data={recentPathList}
                            className={className}
                            searchVal={searchVal}
                            onSelectRepository={handleSelectRepository}
                            checkedRepo={checkedRepo}
                            // 因为埋点需求区分是最近使用列表还是仅展示有权限的知识库，新增operationType字段
                            // 最近使用列表类型为1，仅展示有权限的知识库列表类型为2，默认为0
                            operationType={1}
                        />
                    </> : null
                }
                <div className={styles.listExplain}>仅展示有权限的知识库</div>
                <MenuList
                    data={list}
                    className={className}
                    searchVal={searchVal}
                    onSelectRepository={handleSelectRepository}
                    checkedRepo={checkedRepo}
                    operationType={2}
                />
                {
                    loading && list.length !== 0
                        ? <Loading />
                        : null
                }
                {
                    list.length === 0 && !hasMore && !error && !loading
                        ? <NoResult />
                        : null
                }
                {
                    !hasMore && list.length > 0 && !error && !loading
                        ? <Loaded />
                        : null
                }
                {
                    error && !loading && page !== 1
                        ? <LoadError
                            onReload={
                                () => {
                                    loadMore(page);
                                }
                            }
                        />
                        : null
                }
            </div>
        </div>

    );
}
